import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"
import store from "store"

import {
    Select,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue as change,
} from "app/reducers/form";

import { UPDATE_SETTINGS } from "template-edit/reducers"
import { Project } from "app/types/model-types";
import { SettingsSpinner } from "./spinner";
import { ReduxList } from "app/types/app-types";
import { getCategories, getProjectCategories, saveProjectCategories } from "app/helpers/api"
import { AxiosResponse } from "axios"
import { Option } from "@bdfx/mergado-ui-kit/lib/components/Form/Select"
import { createToast } from "actions";
import toastFactory from "app/helpers/toast_factory";

export type CategoryType = {
    id: number
    trans_string: string
    name: string
}

export type ProjectCategoryType = {
    id: number
    project_id: number
    category_id: number
}

interface Props {
    project: ReduxList<Project>
}

interface State {
    categories: CategoryType[]
    projectCategories: number[]
}

class ProjectCategories extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            categories: null,
            projectCategories: null,
        }
    }

    setProjectCategories = (projectCategories: number[]) => {
        this.setState({ projectCategories: projectCategories })
        this.saveProjectCategories(projectCategories)
    }

    saveProjectCategories = (projectCategories: number[]) => {
        saveProjectCategories(projectCategories)
            .then((response: AxiosResponse<any>) => {
            }).catch(error => {
                console.error('cannot save project categories', error)
                store.dispatch(createToast(toastFactory(UPDATE_SETTINGS.ERROR, error)))
            })
    }

    componentDidMount() {
        getCategories()
            .then((response: AxiosResponse<CategoryType[]>) => {
                this.setState({ categories: response.data })
            })
            .catch(e => console.error('cannot get categories', e))

        getProjectCategories()
            .then((response: AxiosResponse<number[]>) => {
                this.setState({ projectCategories: response.data })
            })
            .catch(e => console.error('cannot get project categories', e))
    }

    render() {
        const { categories, projectCategories } = this.state

        if (!categories) {
            return (
                <SettingsSpinner />
            )
        }
        const categoryOptions : Option[] = categories ? categories.map((c) => {
            return {
                    value: c.id,
                    label: trans(c.trans_string),
                }
        }) : null

        return (
            <React.Fragment>
                <GridCell>{trans('categories')}</GridCell>
                <GridCell>
                    {categoryOptions &&
                        <Select
                            small={true}
                            multiple={true}
                            options={categoryOptions}
                            value={projectCategories ? projectCategories : []}
                            notClearable={true}
                            closeOnChange={true}
                            onChange={(value) => this.setProjectCategories(value)}
                            onClear={() => this.setProjectCategories([])}
                        />
                    }
                </GridCell>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        project: state.project,
    }
}

export default connect(mapStateToProps, {
})(ProjectCategories)

